export default {
    FETCH_FOR_ORGANIZATION: 'ROLES/FETCH_FOR_ORGANIZATION',
    FETCH_FOR_ORGANIZATION_FAILED: 'ROLES/FETCH_FOR_ORGANIZATION_FAILED',
    FETCH_FOR_ORGANIZATION_SUCCESS: 'ROLES/FETCH_FOR_ORGANIZATION_SUCCESS',
};
